<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="program_breadcrumb" />
    </div>
    <div class="header">
      <h1 class="overlay">PROGRAM INFORMATION</h1>
      <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>
    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('challenger_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('challenger_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P015'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="3" :thumb-slide-width="45" />
      </div>
      <div class="container subContainer">
        <div class="row d-flex justify-content-center">
          <div class="col-lg-12 mainInfo">
            <!--            <div>핀크스골프클럽에서 진행되는 프리미엄 필드레슨 프로그램입니다.</div>
            <div>
              스윙체크 등의 기본과 트러블 샷 관리, 숏게임 스킬, 퍼팅 등의 특별한 레슨을 통해 개인의 골프실력을 향상시켜
              드립니다.
            </div>-->
            <div style="word-break: keep-all">
              {{ $t('challenger_desc1') }}
            </div>
            <div style="word-break: keep-all">
              {{ $t('challenger_desc2') }}
            </div>
            <div>{{ $t('challenger_desc3') }}</div>
          </div>
        </div>
      </div>
      <div class="rowSpace"><hr /></div>
      <div class="col-lg-12 serviceArea">
        <div class="subTitle">{{ $t('challenger_common_title') }}</div>
        <div class="subDetail">
          <div>{{ $t('challenger_common_desc1') }}</div>
          <div>{{ $t('challenger_common_desc2') }}</div>
          <div>{{ $t('challenger_common_desc3') }}</div>
        </div>
      </div>
      <div class="rowSpace"><hr /></div>
      <div class="col-lg-12 serviceArea">
        <div class="subTitle">{{ $t('challenger_main_title') }}</div>
        <div class="subDetail">{{ $t('challenger_main_desc1') }}</div>
        <div class="subDetail">{{ $t('challenger_main_desc2') }}</div>

        <div class="rowSpace"></div>

        <table class="web table table-bordered subTable mobileTable">
          <thead>
            <tr>
              <td>{{ $t('challenger_table1_tr1_td1') }}</td>
              <td>{{ $t('challenger_table1_tr1_td2') }}</td>
              <td>{{ $t('challenger_table1_tr1_td3') }}</td>
              <td colspan="2">{{ $t('challenger_table1_tr1_td4') }}</td>
              <td>{{ $t('challenger_table1_tr1_td5') }}</td>
              <td>{{ $t('challenger_table1_tr1_td6') }}</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td rowspan="2" v-html="$t('challenger_table1_tr2_td1')"></td>
              <td rowspan="4" v-html="$t('challenger_table1_tr2_td2')"></td>
              <td rowspan="2">{{ $t('challenger_table1_tr2_td3') }}</td>
              <td>{{ $t('challenger_table1_tr2_td4') }}</td>
              <td>{{ $t('challenger_table1_tr2_td5') }}</td>
              <td>{{ $t('challenger_table1_tr2_td6') }}</td>
              <td rowspan="4">{{ $t('challenger_table1_tr2_td7') }}</td>
            </tr>
            <tr>
              <td>{{ $t('challenger_table1_tr3_td1') }}</td>
              <td>{{ $t('challenger_table1_tr3_td2') }}</td>
              <td>{{ $t('challenger_table1_tr3_td3') }}</td>
            </tr>
            <tr>
              <td rowspan="2">{{ $t('challenger_table1_tr4_td1') }}</td>
              <td rowspan="2">{{ $t('challenger_table1_tr4_td2') }}</td>
              <td>{{ $t('challenger_table1_tr4_td3') }}</td>
              <td>{{ $t('challenger_table1_tr4_td4') }}</td>
              <td>{{ $t('challenger_table1_tr4_td5') }}</td>
            </tr>
            <tr>
              <td>{{ $t('challenger_table1_tr5_td1') }}</td>
              <td>{{ $t('challenger_table1_tr5_td2') }}</td>
              <td>{{ $t('challenger_table1_tr5_td3') }}</td>
            </tr>
          </tbody>
        </table>

        <table class="mobile table table-bordered subTable mobileTable">
          <tbody>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td1') }}</td>
              <td v-html="$t('challenger_table1_tr2_td1')"></td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td2') }}</td>
              <td v-html="$t('challenger_table1_tr2_td2')"></td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td3') }}</td>
              <td>{{ $t('challenger_table1_tr2_td3') }}</td>
            </tr>
            <tr>
              <td rowspan="2" class="subTable2">{{ $t('challenger_table1_tr1_td4') }}</td>
              <td>{{ $t('challenger_table1_tr2_td4') }}</td>
            </tr>
            <tr>
              <td>{{ $t('challenger_table1_tr2_td5') }}</td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td5') }}</td>
              <td>{{ $t('challenger_table1_tr2_td6') }}</td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td6') }}</td>
              <td>{{ $t('challenger_table1_tr2_td7') }}</td>
            </tr>
          </tbody>
        </table>

        <table class="mobile table table-bordered subTable mobileTable">
          <tbody>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td1') }}</td>
              <td v-html="$t('challenger_table1_tr2_td1')"></td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td2') }}</td>
              <td v-html="$t('challenger_table1_tr2_td2')"></td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td3') }}</td>
              <td>{{ $t('challenger_table1_tr2_td3') }}</td>
            </tr>
            <tr>
              <td rowspan="2" class="subTable2">{{ $t('challenger_table1_tr1_td4') }}</td>
              <td>{{ $t('challenger_table1_tr3_td1') }}</td>
            </tr>
            <tr>
              <td>{{ $t('challenger_table1_tr3_td2') }}</td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td5') }}</td>
              <td>{{ $t('challenger_table1_tr3_td3') }}</td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td6') }}</td>
              <td>{{ $t('challenger_table1_tr2_td7') }}</td>
            </tr>
          </tbody>
        </table>

        <table class="mobile table table-bordered subTable mobileTable">
          <tbody>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td1') }}</td>
              <td v-html="$t('challenger_table1_tr4_td1')"></td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td2') }}</td>
              <td v-html="$t('challenger_table1_tr2_td2')"></td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td3') }}</td>
              <td>{{ $t('challenger_table1_tr4_td2') }}</td>
            </tr>
            <tr>
              <td rowspan="2" class="subTable2">{{ $t('challenger_table1_tr1_td4') }}</td>
              <td>{{ $t('challenger_table1_tr4_td3') }}</td>
            </tr>
            <tr>
              <td>{{ $t('challenger_table1_tr4_td4') }}</td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td5') }}</td>
              <td>{{ $t('challenger_table1_tr4_td5') }}</td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td6') }}</td>
              <td>{{ $t('challenger_table1_tr2_td7') }}</td>
            </tr>
          </tbody>
        </table>

        <table class="mobile table table-bordered subTable mobileTable">
          <tbody>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td1') }}</td>
              <td v-html="$t('challenger_table1_tr4_td1')"></td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td2') }}</td>
              <td v-html="$t('challenger_table1_tr2_td2')"></td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td3') }}</td>
              <td>{{ $t('challenger_table1_tr4_td2') }}</td>
            </tr>
            <tr>
              <td rowspan="2" class="subTable2">{{ $t('challenger_table1_tr1_td4') }}</td>
              <td>{{ $t('challenger_table1_tr5_td1') }}</td>
            </tr>
            <tr>
              <td>{{ $t('challenger_table1_tr5_td2') }}</td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td5') }}</td>
              <td>{{ $t('challenger_table1_tr5_td3') }}</td>
            </tr>
            <tr>
              <td class="subTable2">{{ $t('challenger_table1_tr1_td6') }}</td>
              <td>{{ $t('challenger_table1_tr2_td7') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="container">
      <div class="rowSpace"><hr /></div>
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('challenger_addition_title') }}</div>
          <GallerySlideCarousels :slides="addition_slides" :slide-count="4" :thumb-slide-width="50" />
          <div class="container">
            <table class="col-lg-12 col-sm-3 table table-bordered subTable mobileTable">
              <thead>
                <tr>
                  <td>{{ $t('challenger_table2_tr1_td1') }}</td>
                  <td colspan="2">{{ $t('challenger_table2_tr1_td2') }}</td>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('challenger_table2_tr2_td1') }}</td>
                  <td>{{ $t('challenger_table2_tr2_td2') }}</td>
                  <td rowspan="6">{{ $t('challenger_table2_tr2_td3') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('challenger_table2_tr3_td1') }}</td>
                  <td>{{ $t('challenger_table2_tr3_td2') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('challenger_table2_tr4_td1') }}</td>
                  <td>{{ $t('challenger_table2_tr4_td2') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('challenger_table2_tr5_td1') }}</td>
                  <td>{{ $t('challenger_table2_tr5_td2') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('challenger_table2_tr6_td1') }}</td>
                  <td>{{ $t('challenger_table2_tr6_td2') }}</td>
                </tr>
                <tr>
                  <td>{{ $t('challenger_table2_tr7_td1') }}</td>
                  <td>{{ $t('challenger_table2_tr7_td2') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('challenger_etc_title') }}</div>
          <div class="subDetail">
            <div>{{ $t('challenger_etc_desc1') }}</div>
            <div>{{ $t('challenger_etc_desc2') }}</div>
            <div>{{ $t('challenger_etc_desc3') }}</div>
            <div>{{ $t('challenger_etc_desc4') }}</div>
            <div>{{ $t('challenger_etc_desc5') }}</div>
            <div>{{ $t('challenger_etc_desc6') }}</div>
            <div>{{ $t('challenger_etc_desc7') }}</div>
          </div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
          <router-link
            v-show="isLang === 0"
            :to="{name: 'Realtimebooking2', params: {initProgramCode: 'P015'}}"
            class="resserve-button"
          >
            {{ $t('reserve_button') }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'challengergolf',
  components: {Breadcrumb, GallerySlideCarousels},
  data() {
    return {
      isLang: 0,
      program_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/program/challengergolf_main_01.jpg')},
        {image: require('@/assets/images/pleisure/program/challengergolf_main_02.jpg')},
        {image: require('@/assets/images/pleisure/program/challengergolf_main_03.jpg')},
      ],
      addition_slides: [
        {image: require('@/assets/images/pleisure/program/challengergolf_option_01.jpg')},
        {image: require('@/assets/images/pleisure/program/challengergolf_option_02.jpg')},
        {image: require('@/assets/images/pleisure/program/challengergolf_option_03.jpg')},
        {image: require('@/assets/images/pleisure/program/vonestis_option_01.jpg')},
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'PROGRAM',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
};
</script>

<style scoped lang="scss">
.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
td {
  vertical-align: middle;
}
.top {
  padding-top: 11rem;
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  > div {
    line-height: 1.5rem;
    font-size: 1rem;
  }
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
      word-break: keep-all;
    }
  }
}

.subTable2 {
  font-weight: bold;
}
.subTable3 {
  background-color: #f3f3f3;
  font-weight: bold;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

.headerimage {
  width: 100%;
  margin: 0;
  content: url('~@/assets/images/pleisure/program/challengergolf_headerimage.jpg');
}

@media (min-width: 992px) {
  .web {
  }

  .mobile {
    display: none;
  }
}

@media (max-width: 992px) {
  .headerimage {
    display: none;
  }

  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: lighter;
      letter-spacing: -0.1rem;
    }
  }
  .web {
    display: none;
  }

  .mobile {
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "프로그램 안내",
    "challenger_title": "챌린저 골프",
    "challenger_subtitle": "한국 최초의 세계 100대 골프장에서 경험하는 프리미엄 골프 레슨",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "challenger_desc1": "한국 최초의 세계 100대 골프장 핀크스에서 경험하는 프리미엄 골프 레슨 프로그램.",
    "challenger_desc2": "스윙 체크 등의 기본과 트러블 샷 관리, 숏게임 스킬, 퍼팅 등의 특별한 레슨을 통해 개인의 골프 실력을 향상시켜 드립니다.",
    "challenger_desc3": "※ 연령제한 14세 이상",
    "challenger_common_title": "공통 의전 및 서비스",
    "challenger_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "challenger_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "challenger_common_desc3": "- 어메니티, 미니바 제공",
    "challenger_main_title": "메인 프로그램",
    "challenger_main_desc1": "· 장소 : 핀크스 골프클럽",
    "challenger_main_desc2": "· 프로그램 : 원포인트, 필드레슨, 레슨 전/후 개인 맞춤 프로그램",
    "challenger_table1_tr1_td1": "옵션",
    "challenger_table1_tr1_td2": "최대인원",
    "challenger_table1_tr1_td3": "소요시간",
    "challenger_table1_tr1_td4": "요금(2인기준)",
    "challenger_table1_tr1_td5": "인원 추가비",
    "challenger_table1_tr1_td6": "비고",
    "challenger_table1_tr2_td1": "원포인트<br/>+필드레슨",
    "challenger_table1_tr2_td2": "3인<br/>(1인 이용불가)",
    "challenger_table1_tr2_td3": "5 ~ 5.5H",
    "challenger_table1_tr2_td4": "월 ~ 금 1부",
    "challenger_table1_tr2_td5": "1,900,000",
    "challenger_table1_tr2_td6": "330,000",
    "challenger_table1_tr2_td7": "※ 캐디피 별도",
    "challenger_table1_tr3_td1": "금2부 ~ 일",
    "challenger_table1_tr3_td2": "2,100,000",
    "challenger_table1_tr3_td3": "400,000",
    "challenger_table1_tr4_td1": "필드레슨",
    "challenger_table1_tr4_td2": "4.5 ~ 5H",
    "challenger_table1_tr4_td3": "월 ~ 금 1부",
    "challenger_table1_tr4_td4": "1,700,000",
    "challenger_table1_tr4_td5": "280,000",
    "challenger_table1_tr5_td1": "금2부 ~ 일",
    "challenger_table1_tr5_td2": "1,900,000",
    "challenger_table1_tr5_td3": "350,000",
    "challenger_addition_title": "추가옵션",
    "challenger_table2_tr1_td1": "구분",
    "challenger_table2_tr1_td2": "옵션(2인기준)",
    "challenger_table2_tr2_td1": "150,000",
    "challenger_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "challenger_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "challenger_table2_tr3_td1": "200,000",
    "challenger_table2_tr3_td2": "메디컬 스파(바디)",
    "challenger_table2_tr4_td1": "350,000",
    "challenger_table2_tr4_td2": "오모로비짜 스파(90분)",
    "challenger_table2_tr5_td1": "400,000",
    "challenger_table2_tr5_td2": "본에스티스 스파(90분)",
    "challenger_table2_tr6_td1": "500,000",
    "challenger_table2_tr6_td2": "스냅(요트)",
    "challenger_table2_tr7_td1": "플라워 세팅",
    "challenger_table2_tr7_td2": "300,000 / 500,000 / 700,000",
    "challenger_etc_title": "기타사항",
    "challenger_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "challenger_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "challenger_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "challenger_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "challenger_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "challenger_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "challenger_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  },
  "en": {
    "breadcrumb": "Program Information",
    "challenger_title": "Challenger Golf",
    "challenger_subtitle": "Premium golf lesson experiencing in Korea's first top 100 golf courses in the world.",
    "prev_button": "Previous",
    "reserve_button": "Book Now",
    "challenger_desc1": "Experience the premium golf lesson in Korea's first top 100 golf courses in the world.",
    "challenger_desc2": "You can improve golf skills through special lessons for not only basic swing check, but trouble shot management, short game skills, and putting.",
    "challenger_desc3": "※ Available only for 14 years old or older.",
    "challenger_common_title": "Common escort service and other services",
    "challenger_common_desc1": "- Escort vehicle service (Benz Sprinter / Carnival High Limousine)",
    "challenger_common_desc2": "- Care service by the PINX escort manager",
    "challenger_common_desc3": "- Free amenities and minibar",
    "challenger_main_title": "Main Program",
    "challenger_main_desc1": "· Location : PINX Golf club",
    "challenger_main_desc2": "· Program : One-point lesson, Field lesson, Personal customized program before and after lesson",
    "challenger_table1_tr1_td1": "Option",
    "challenger_table1_tr1_td2": "Maximum Occupancy",
    "challenger_table1_tr1_td3": "Total Time",
    "challenger_table1_tr1_td4": "Fare(2 people)",
    "challenger_table1_tr1_td5": "Additioinal person",
    "challenger_table1_tr1_td6": "Option",
    "challenger_table1_tr2_td1": "One-point lesson<br/>+ Field lesson",
    "challenger_table1_tr2_td2": "3 people<br/>(Not available for 1 person)",
    "challenger_table1_tr2_td3": "5 ~ 5.5H",
    "challenger_table1_tr2_td4": "Monday ~ Part1 on Friday",
    "challenger_table1_tr2_td5": "KRW 1,900,000",
    "challenger_table1_tr2_td6": "KRW 330,000",
    "challenger_table1_tr2_td7": "※ Caddie fee is not included",
    "challenger_table1_tr3_td1": "Part2 on Friday ~ Part1 on Sunday",
    "challenger_table1_tr3_td2": "KRW 2,10,000",
    "challenger_table1_tr3_td3": "KRW 400,000",
    "challenger_table1_tr4_td1": "Field lesson",
    "challenger_table1_tr4_td2": "4.5 ~ 5H",
    "challenger_table1_tr4_td3": "Moday ~ part1 on Friday",
    "challenger_table1_tr4_td4": "KRW 1,700,000",
    "challenger_table1_tr4_td5": "KRW 280,000",
    "challenger_table1_tr5_td1": "Part2 on Friday ~ Part1 on Sunday",
    "challenger_table1_tr5_td2": "KRW 1,90,000",
    "challenger_table1_tr5_td3": "KRW 350,000",
    "challenger_addition_title": "Addtional Options",
    "challenger_table2_tr1_td1": "Fare",
    "challenger_table2_tr1_td2": "Option(2 person)",
    "challenger_table2_tr2_td1": "KRW 150,000",
    "challenger_table2_tr2_td2": "Water therapy, Shooting, Omorovicza Spa(40min.)",
    "challenger_table2_tr2_td3": "※ More than 3 people, please contact us",
    "challenger_table2_tr3_td1": "KRW 200,000",
    "challenger_table2_tr3_td2": "Medical Spa(Body)",
    "challenger_table2_tr4_td1": "KRW 350,000",
    "challenger_table2_tr4_td2": "Omorovicza Spa(90min.)",
    "challenger_table2_tr5_td1": "KRW 400,000",
    "challenger_table2_tr5_td2": "Vonestis Spa(90min.)",
    "challenger_table2_tr6_td1": "KRW 500,000",
    "challenger_table2_tr6_td2": "Snapshot(Yacht)",
    "challenger_table2_tr7_td1": "Flower service",
    "challenger_table2_tr7_td2": "KRW 300,000 / 500,000 / 700,000",
    "challenger_etc_title": "Others",
    "challenger_etc_desc1": "※ A fare applies for children aged 5 or older.",
    "challenger_etc_desc2": "※ In some cases, minors may need a guardian.",
    "challenger_etc_desc3": "※ The company’s cancellation policy shall apply in the case of cancellation or refund due to a simple change in mind.",
    "challenger_etc_desc4": "- Penalty will be charged 0% until 7 days prior to the reserved date, 30% from 5 to 6 days before, 50% until 4 days before, 70% until 2 to 3 days before (by 5pm), and no refund will be made(100% penalty) after 5pm 2 days prior to the reserved date.",
    "challenger_etc_desc5": "※ In case of cancellation due to natural disasters or unavoidable circumstances due to the company's operational reason, the cancellation policy shall not apply.",
    "challenger_etc_desc6": "※ Traveler's insurance is included in the product.",
    "challenger_etc_desc7": "※ Contact us by phone for the group of people other than the number in the price list."
  },
  "ja": {
    "breadcrumb": "프로그램 안내",
    "challenger_title": "챌린저 골프",
    "challenger_subtitle": "한국 최초의 세계 100대 골프장에서 경험하는 프리미엄 골프 레슨",
    "prev_button": "이전",
    "reserve_button": "예약신청",
    "challenger_desc1": "한국 최초의 세계 100대 골프장 핀크스에서 경험하는 프리미엄 골프 레슨 프로그램.",
    "challenger_desc2": "스윙 체크 등의 기본과 트러블 샷 관리, 숏게임 스킬, 퍼팅 등의 특별한 레슨을 통해 개인의 골프 실력을 향상시켜 드립니다.",
    "challenger_desc3": "※ 연령제한 14세 이상",
    "challenger_common_title": "공통 의전 및 서비스",
    "challenger_common_desc1": "- 차량 의전 서비스 (벤츠 스프린터 / 카니발 하이리무진)",
    "challenger_common_desc2": "- 핀크스 의전 담당 매니저 케어",
    "challenger_common_desc3": "- 어메니티, 미니바 제공",
    "challenger_main_title": "메인 프로그램",
    "challenger_main_desc1": "· 장소 : 핀크스 골프클럽",
    "challenger_main_desc2": "· 프로그램 : 원포인트, 필드레슨, 레슨 전/후 개인 맞춤 프로그램",
    "challenger_table1_tr1_td1": "옵션",
    "challenger_table1_tr1_td2": "최대인원",
    "challenger_table1_tr1_td3": "소요시간",
    "challenger_table1_tr1_td4": "요금(2인기준)",
    "challenger_table1_tr1_td5": "인원 추가비",
    "challenger_table1_tr1_td6": "비고",
    "challenger_table1_tr2_td1": "원포인트<br/>+필드레슨",
    "challenger_table1_tr2_td2": "3인<br/>(1인 이용불가)",
    "challenger_table1_tr2_td3": "5 ~ 5.5H",
    "challenger_table1_tr2_td4": "월 ~ 금 1부",
    "challenger_table1_tr2_td5": "1,900,000",
    "challenger_table1_tr2_td6": "330,000",
    "challenger_table1_tr2_td7": "※ 캐디피 별도",
    "challenger_table1_tr3_td1": "금2부 ~ 일",
    "challenger_table1_tr3_td2": "2,100,000",
    "challenger_table1_tr3_td3": "400,000",
    "challenger_table1_tr4_td1": "필드레슨",
    "challenger_table1_tr4_td2": "4.5 ~ 5H",
    "challenger_table1_tr4_td3": "월 ~ 금 1부",
    "challenger_table1_tr4_td4": "1,700,000",
    "challenger_table1_tr4_td5": "280,000",
    "challenger_table1_tr5_td1": "금2부 ~ 일",
    "challenger_table1_tr5_td2": "1,900,000",
    "challenger_table1_tr5_td3": "350,000",
    "challenger_addition_title": "추가옵션",
    "challenger_table2_tr1_td1": "구분",
    "challenger_table2_tr1_td2": "옵션(2인기준)",
    "challenger_table2_tr2_td1": "150,000",
    "challenger_table2_tr2_td2": "수테라피, 사격, 오모로비짜 스파(40분)",
    "challenger_table2_tr2_td3": "※ 3인 이상 시 전화 문의",
    "challenger_table2_tr3_td1": "200,000",
    "challenger_table2_tr3_td2": "메디컬 스파(바디)",
    "challenger_table2_tr4_td1": "350,000",
    "challenger_table2_tr4_td2": "오모로비짜 스파(90분)",
    "challenger_table2_tr5_td1": "500,000",
    "challenger_table2_tr5_td2": "스냅(요트)",
    "challenger_table2_tr6_td1": "플라워 세팅",
    "challenger_table2_tr6_td2": "300,000 / 500,000 / 700,000",
    "challenger_etc_title": "기타사항",
    "challenger_etc_desc1": "※ 5세 이상부터 1인 요금이 적용됩니다.",
    "challenger_etc_desc2": "※ 경우에 따라 미성년자의 경우에는 보호자 동반이 필요할 수 있습니다.",
    "challenger_etc_desc3": "※ 단순 고객변심에 의한 취소/환불은 업체 위약 규정에 따라 적용됩니다.",
    "challenger_etc_desc4": "- 7일 전 위약금 0%, 6일 전 ~ 5일 전 30%, 4일 전 50%, 3일 전~2일 전(~17시) 70%, 2일전(17시~) ~ 당일 100% 위약금 부과",
    "challenger_etc_desc5": "※ 천재지변 및 업체의 운영 상 부득이한 상황으로 취소 시, 위약 규정이 적용되지 않습니다.",
    "challenger_etc_desc6": "※ 여행자보험 포함 상품입니다.",
    "challenger_etc_desc7": "※ 요금표 외 기타 인원은 전화 문의"
  }
}
</i18n>
